
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_17ppy_99",
  "refresh": "awsui_refresh_2qdw9_17ppy_138",
  "root-no-actions": "awsui_root-no-actions_2qdw9_17ppy_138",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_17ppy_141",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_17ppy_141",
  "root-has-description": "awsui_root-has-description_2qdw9_17ppy_141",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_17ppy_150",
  "main": "awsui_main_2qdw9_17ppy_160",
  "no-wrap": "awsui_no-wrap_2qdw9_17ppy_170",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_17ppy_176",
  "actions": "awsui_actions_2qdw9_17ppy_184",
  "actions-centered": "awsui_actions-centered_2qdw9_17ppy_189",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_17ppy_192",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_17ppy_196",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_17ppy_200",
  "title": "awsui_title_2qdw9_17ppy_216",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_17ppy_221",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_17ppy_228",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_17ppy_234",
  "virtual-space": "awsui_virtual-space_2qdw9_17ppy_267",
  "info": "awsui_info_2qdw9_17ppy_273",
  "description": "awsui_description_2qdw9_17ppy_277",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_17ppy_284",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_17ppy_288",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_17ppy_295",
  "heading": "awsui_heading_2qdw9_17ppy_304",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_17ppy_315",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_17ppy_320",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_17ppy_325",
  "heading-text": "awsui_heading-text_2qdw9_17ppy_343",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_17ppy_346",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_17ppy_354",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_17ppy_362",
  "counter": "awsui_counter_2qdw9_17ppy_371"
};
  